/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { ComponentInterface } from '@appCanvasCommon/interfaces/component.interface';
import { TicketContainer, TICKET_CHANGE_EVENTS } from '../tickets/TicketContainer';
import { Texture } from 'pixi.js-legacy';
import { TicketComponentHelper } from './TicketComponentHelper';
import { Side } from '@touchplan/common';
import { Ticket } from '@touchplan/common';
import { CanvasAngularLand } from 'src/app/app-data/interfaces/canvas-angular-land';
import { setTicketWidthHelper } from 'src/app/utils/ticket-utils';
import { EventMode } from '@appCanvasCommon/events/event-mode.enum';

export enum IS_LONGEST_SETTINGS {
	PADDING_BOTTOM = 10,
	ROW_HEIGHT = 35,
	LEFT_OFFSET = 15,
}

export class TicketIsLongest extends TicketComponentHelper implements ComponentInterface {
	constructor(texture: Texture, canvasAngularLand: CanvasAngularLand, ticketContainer: TicketContainer) {
		super(texture, canvasAngularLand, ticketContainer);
		this.alpha = 0.5;

		ticketContainer.on(TICKET_CHANGE_EVENTS.CHANGED, this.onChanged);

		this.onChanged(ticketContainer);
		this.eventMode = EventMode.None;
	}

	public onChanged = (ticketContainer: TicketContainer) => {
		const data: Ticket = ticketContainer.getData();
		const layout = ticketContainer.getLayout();
		this.renderable = data.view.side === Side.PULL && data.isLongestPull;
		if (this.renderable) {
			const data: Ticket = this.ticket.getData();
			// Scale this a bit depending on the size of the liveDurationDays
			if (data.view.liveDurationDays >= 10) {
				this.scale.x = 1.5;
			} else {
				this.scale.x = 1;
			}

			const width = setTicketWidthHelper(data, layout, this.canvasAngularLand.wideTicketSize$.getValue());

			this.x = width - this.width - IS_LONGEST_SETTINGS.LEFT_OFFSET;
			// padding-bottom: 20px
			// Align to bottom-right, then offset the height and 20
			// 28 is the height of TicketDurationDays.
			// 20 is the spacing we want.
			this.y = layout.height - IS_LONGEST_SETTINGS.ROW_HEIGHT - IS_LONGEST_SETTINGS.PADDING_BOTTOM;
		}
	};

	public override destroy(options?) {
		this.ticket.off(TICKET_CHANGE_EVENTS.CHANGED, this.onChanged);
		super.destroy(options);
	}
}
